module.exports = __webpack_public_path__ + "static/media/logo.c9035220.svg";